module.exports = __webpack_public_path__ + "static/slider-1-f9c5302d005a524135da404adaef999b.jpg";